import { render, staticRenderFns } from "./StickersCRUD.vue?vue&type=template&id=42e2ec0e"
import script from "./StickersCRUD.vue?vue&type=script&lang=js"
export * from "./StickersCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports